module.exports = __webpack_public_path__ + "static/media/btn_android_es.157ce83f.png";